var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "extracharges"
  }, [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.parentObj) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("ADD EXTRA CHARGES")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Trip List"
    },
    on: {
      "click": _vm.showAddExtraCharges
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (!_vm.parentObj) ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Allocation Type")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.allocationTypeList,
      "placeholder": "Select Allocation Type",
      "append-to-body": true,
      "name": "allocationtype"
    },
    model: {
      value: (_vm.allocationtypesearch),
      callback: function($$v) {
        _vm.allocationtypesearch = $$v
      },
      expression: "allocationtypesearch"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Shipping ID")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card-o' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "shippingid",
      "id": "shippingid",
      "placeholder": "Enter Shipping ID"
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.awbErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Clear")])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "AssignedBA/SR",
      "id": "chck6"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck6"
    }
  }, [_vm._v("Add Charges ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Odd Size Shipments Charges (>100 Kg/MPS)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingsize),
      expression: "shippingsize"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "shippingsize",
      "id": "shippingsize",
      "placeholder": "Enter Odd Size Shipments Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.shippingsize)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingsize = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "ShipmentDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.shipmentdoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.shipmentsizedocument.Location == '' ? 'required' : ''))),
      expression: "`${shipmentsizedocument.Location == '' ? 'required' : ''}`"
    }],
    ref: "files",
    attrs: {
      "id": "ShipmentDocument",
      "name": "ShipmentDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadShipmentSizeDoc
    }
  }), _vm._v(" "), (_vm.shipmentdoc == 'png' || _vm.shipmentdoc == 'jpg' || _vm.shipmentdoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.shipmentsizedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.shipmentsizedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.shipmentsizedocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.shipmentsizedocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.shipmentsizedocument.Location,
      "src": _vm.shipmentsizedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.shipmentdoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.shipmentsizedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shipmentdoc == 'doc' || _vm.shipmentdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.shipmentsizedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.shipmentdoc == 'png' || _vm.shipmentdoc == 'jpg' || _vm.shipmentdoc == 'jpeg' || _vm.shipmentdoc == 'pdf' || _vm.shipmentdoc == 'doc' || _vm.shipmentdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('shipmentsize')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Client approval required to \n\t\t\t\t\t\t\tupload the charge for this category.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Mathadi/Varai/Union Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mathadi),
      expression: "mathadi"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "mathadi",
      "id": "mathadi",
      "placeholder": "Enter Mathadi/Varai/Union Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.mathadi)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mathadi = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "MathadiDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.mathadidoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "MathadiDocument",
      "name": "MathadiDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadMathadiDoc
    }
  }), _vm._v(" "), (_vm.mathadidoc == 'png' || _vm.mathadidoc == 'jpg' || _vm.mathadidoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.mathadidocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.mathadidocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.mathadidocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.mathadidocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.mathadidocument.Location,
      "src": _vm.mathadidocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.mathadidoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.mathadidocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mathadidoc == 'doc' || _vm.mathadidoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.mathadidocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.mathadidoc == 'png' || _vm.mathadidoc == 'jpg' || _vm.mathadidoc == 'jpeg' || _vm.mathadidoc == 'pdf' || _vm.mathadidoc == 'doc' || _vm.mathadidoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('mathadi')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Open Pick-up / Delivery Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portage),
      expression: "portage"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "portage",
      "id": "portage",
      "placeholder": "Enter Open Pick-up / Delivery Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.portage)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.portage = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "PortgagesDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.portgagesdoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "PortgagesDocument",
      "name": "PortgagesDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadPortgageDoc
    }
  }), _vm._v(" "), (_vm.portgagesdoc == 'png' || _vm.portgagesdoc == 'jpg' || _vm.portgagesdoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.portgagedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.portgagedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.portgagedocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.portgagedocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.portgagedocument.Location,
      "src": _vm.portgagedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.portgagesdoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.portgagedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.portgagesdoc == 'doc' || _vm.portgagesdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.portgagedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.portgagesdoc == 'png' || _vm.portgagesdoc == 'jpg' || _vm.portgagesdoc == 'jpeg' || _vm.portgagesdoc == 'pdf' || _vm.portgagesdoc == 'doc' || _vm.portgagesdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('portgage')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Appointment/CSD/Mall Delivery Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialcharge),
      expression: "specialcharge"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "specialcharge",
      "id": "specialcharge",
      "placeholder": "Enter Appointment/CSD/Mall Delivery Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.specialcharge)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.specialcharge = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "SpecialChargeDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.specialchargedoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "SpecialChargeDocument",
      "name": "SpecialChargeDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadSpecialChargeDoc
    }
  }), _vm._v(" "), (_vm.specialchargedoc == 'png' || _vm.specialchargedoc == 'jpg' || _vm.specialchargedoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.specialchargedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.specialchargedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.specialchargedocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.specialchargedocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.specialchargedocument.Location,
      "src": _vm.specialchargedocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.specialchargedoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.specialchargedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.specialchargedoc == 'doc' || _vm.specialchargedoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.specialchargedocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.specialchargedoc == 'png' || _vm.specialchargedoc == 'jpg' || _vm.specialchargedoc == 'jpeg' || _vm.specialchargedoc == 'pdf' || _vm.specialchargedoc == 'doc' || _vm.specialchargedoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('specialcharge')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Floor Pick-up/Delivery Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadcharges),
      expression: "loadcharges"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "loadcharges",
      "id": "loadcharges",
      "placeholder": "Enter Floor Pick-up / Delivery",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.loadcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loadcharges = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "LoadingDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.loadingdoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "LoadingDocument",
      "name": "LoadingDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadLoadingDoc
    }
  }), _vm._v(" "), (_vm.loadingdoc == 'png' || _vm.loadingdoc == 'jpg' || _vm.loadingdoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.loadingdocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.loadingdocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.loadingdocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.loadingdocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.loadingdocument.Location,
      "src": _vm.loadingdocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.loadingdoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.loadingdocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadingdoc == 'doc' || _vm.loadingdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.loadingdocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.loadingdoc == 'png' || _vm.loadingdoc == 'jpg' || _vm.loadingdoc == 'jpeg' || _vm.loadingdoc == 'pdf' || _vm.loadingdoc == 'doc' || _vm.loadingdoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('loading')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("ODA Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oda),
      expression: "oda"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "oda",
      "id": "oda",
      "placeholder": "Enter ODA Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.oda)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oda = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "ODADocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.odadoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "ODADocument",
      "name": "ODADocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadODADoc
    }
  }), _vm._v(" "), (_vm.odadoc == 'png' || _vm.odadoc == 'jpg' || _vm.odadoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.odadocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.odadocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.odadocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.odadocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.odadocument.Location,
      "src": _vm.odadocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.odadoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.odadocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.odadoc == 'doc' || _vm.odadoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.odadocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                            "), (_vm.odadoc == 'png' || _vm.odadoc == 'jpg' || _vm.odadoc == 'jpeg' || _vm.odadoc == 'pdf' || _vm.odadoc == 'doc' || _vm.odadoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('oda')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Other Charges")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fulltruckload),
      expression: "fulltruckload"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "fulltruckload",
      "id": "fulltruckload",
      "placeholder": "Enter Other Charges",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.fulltruckload)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fulltruckload = $event.target.value
      }
    }
  })]), _vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('b-input-group', [(this.fulltruckload != '' && this.fulltruckload > 0) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addOtherChargesRemarks),
      expression: "addOtherChargesRemarks"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "name": "remarksdata",
      "id": "remarksdata",
      "cols": "50",
      "rows": "15",
      "placeholder": "Enter Other Charges Remarks",
      "maxlength": 250
    },
    domProps: {
      "value": (_vm.addOtherChargesRemarks)
    },
    on: {
      "keypress": function($event) {
        _vm.isRemaksAdded($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addOtherChargesRemarks = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('small', {
    staticClass: "form-text",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "remarknote",
      "name": "remarknote"
    }
  }, [_vm._v("Note*: Adding Remarks for other charges mandatory")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "30px 0px 0px 0px"
    },
    attrs: {
      "for": "FullTruckLoadDocument"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  }), _vm._v("  "), (_vm.fulltruckloaddoc == '') ? _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "FullTruckLoadDocument",
      "name": "FullTruckLoadDocument",
      "type": "file"
    },
    on: {
      "change": _vm.uploadFullTruckLoadDoc
    }
  }), _vm._v(" "), (_vm.fulltruckloaddoc == 'png' || _vm.fulltruckloaddoc == 'jpg' || _vm.fulltruckloaddoc == 'jpeg') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "Open Image"
    },
    on: {
      "click": function($event) {
        _vm.openImage(_vm.fulltruckloaddocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.fulltruckloaddocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.fulltruckloaddocument.Location
    }
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.fulltruckloaddocument.Location)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.fulltruckloaddocument.Location,
      "src": _vm.fulltruckloaddocument.Location
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })]), _vm._v(" "), (_vm.fulltruckloaddoc == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.fulltruckloaddocument.Location)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fulltruckloaddoc == 'doc' || _vm.fulltruckloaddoc == 'docx') ? _c('i', {
    staticClass: "fa fa-file-word-o",
    attrs: {
      "title": "Download Document",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.fulltruckloaddocument.Location)
      }
    }
  }) : _vm._e(), _vm._v("  \n                                "), (_vm.fulltruckloaddoc == 'png' || _vm.fulltruckloaddoc == 'jpg' || _vm.fulltruckloaddoc == 'jpeg' || _vm.fulltruckloaddoc == 'pdf' || _vm.fulltruckloaddoc == 'doc' || _vm.fulltruckloaddoc == 'docx') ? _c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true",
      "title": "Remove Document"
    },
    on: {
      "click": function($event) {
        _vm.selectRemove('fulltruckload')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format\n                            JPG,JPEG,PDF,PNG,DOC,DOCX.")]), _vm._v(" "), _c('div', {
    staticClass: "clientnote "
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to\n                            5MB.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isSave
    },
    on: {
      "click": _vm.saveCharges
    }
  }, [_vm._v(" Save")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearCharges
    }
  }, [_c('i', {
    staticClass: "fa fa-"
  }), _vm._v(" Clear")])])], 1)])])])])]), _vm._v(" "), (_vm.showprint) ? _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('AddExtraChargesPDF', {
    attrs: {
      "payload": _vm.pdfpayload
    }
  })], 1) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78498974","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/AddExtraCharges/CreateExtraCharges/ShowExtraCharges.component.html
// module id = 1415
// module chunks = 3